// @/components/auth/WelcomeCard.jsx
// Reusable card wrapper for auth screens with title, subtitle, and content

import React from "react";
import { motion } from 'motion/react';
import { INTRO } from '@/components/reusable/animations';

const WelcomeCard = ({ title, subtitle, children }) => (
  <motion.div {...INTRO} className="mx-auto max-w-6xl">
    <div className="flex flex-col items-center justify-center text-center">
      <div className="space-y-4 mx-auto">
        <h1>{title}</h1>
        <h4 className="font-medium">{subtitle}</h4>
      </div>
      {children}
    </div>
  </motion.div>
);

export default WelcomeCard;
